import React from "react";

const ErrorPage = () => {
  return (
    <div className="content-outer">
      <div className="content">
        <div>
          <h1>Error</h1>
          <p>User not logged as a admin.</p>
          <p>Please login as a admin to access this page.</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
